<template>
  <div id="app">
    <Tutorial v-if="showTutorial" @close="toggleTutorial" />
    
    <main>
      <section id="left">
        <DJDeck
          ref="leftDeck"
          :song="leftSong"
          :tempoRange="tempoRange"
          :jogSpeed="jogSpeed"
          :timeFactor="timeFactor"
          @loadSong="loadSong('left')"
          @sync="showDislikeNotification"
        />
      </section>

      <section id="right">
        <DJDeck
          ref="rightDeck"
          :song="rightSong"
          :tempoRange="tempoRange"
          :jogSpeed="jogSpeed"
          :timeFactor="timeFactor"
          @loadSong="loadSong('right')"
          @sync="showDislikeNotification"
        />
      </section>

      <Crossfade ref="crossfade" />
    </main>

    <SongLoader :songs="songs" @setSong="setSong" />
    <p id="log"></p>
  </div>
</template>

<script>
import DJDeck from '../components/DJDeck.vue';
import Crossfade from '../components/Crossfade.vue';
import SongLoader from '../components/SongLoader.vue';
import Tutorial from '../components/Tutorial.vue';

export default {
  name: 'App',
  components: {
    DJDeck,
    Crossfade,
    SongLoader,
    Tutorial
  },
  data() {
    return {
      showTutorial: false,
      tempoRange: 20,
      jogSpeed: 5,
      timeFactor: 0.1,
      leftSong: null,
      rightSong: null,
      songs: [
        { id: 1, title: 'Push [Mak & Pasteman Remix]', artist: 'A-Trak feat. Andrew Wyatt', duration: '06:59', bpm: 126, url: 'http://www.michelacosta.com/html5/push.mp3' },
        { id: 2, title: 'Thinking Of You [Original Mix]', artist: 'South Royston', duration: '06:44', bpm: 124, url: 'http://www.michelacosta.com/html5/royston.mp3' },
        { id: 3, title: 'On A Ragga Tip [Original Mix]', artist: 'My Digital Enemy', duration: '04:57', bpm: 125, url: 'http://www.michelacosta.com/html5/ragga.mp3' },
        { id: 4, title: '90s By Nature [Lucas & Steve Remix]', artist: 'Showtek feat MC Ambush', duration: '04:37', bpm: 125, url: 'http://www.michelacosta.com/html5/showtek.mp3' },
      ],
    };
  },
  methods: {
    toggleTutorial() {
      this.showTutorial = !this.showTutorial;
    },
    loadSong(deck) {
      this.$refs[`${deck}Deck`].loadSong();
    },
    setSong({ id, deck }) {
      const song = this.songs.find(song => song.id === id);
      if (deck === 'left') {
        this.leftSong = new Audio(song.url);
      } else {
        this.rightSong = new Audio(song.url);
      }
    },
    showDislikeNotification() {
      if (Notification.permission === 'granted') {
        new Notification('¡Desprecio infinito!', {
          body: 'No nos gustan los DJs que usan el SYNC',
          icon: 'http://www.michelacosta.com/yo.png',
        });
      }
    },
  },
};
</script>

<style scoped src="../assets/style.css"></style>
